<template>
    <div>
        <b-form @submit.prevent="saveLanguage()" data-vv-scope="formLanguages">
            <b-row>
                <b-col md="12">
                    <b-form-group>
                        <label>Lenguaje <span class="text-danger">*</span></label>
                        <el-select @change="setNameLanguage" v-model="language.code" clearable filterable size="medium"
                            placeholder="Seleccionar lenguaje" name="code" v-validate="'required'" data-vv-as=" ">
                            <el-option v-for="item in languagesValidForApi" :key="item.code" :label="item.full_name"
                                :value="item.code" />
                        </el-select>
                        <span class="text-danger small" v-text="errors.first('formLanguages.code')" />
                    </b-form-group>
                </b-col>

                <b-col md="12" class="mt-3 d-flex justify-content-end align-items-center">
                    <b-form-group>
                        <b-button variant="danger" @click="cancelLanguage">
                            <i class="fa fa-reply"></i>
                            <span class="ml-1" v-text="'Cancelar'"></span>
                        </b-button>
                        <b-button type="submit" variant="primary" class="mx-1">
                            <i class="fa fa-save"></i>
                            <span class="ml-1" v-text="'Guardar'"></span>
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>

    </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';
export default {
    name: 'formLanguages',

    computed: {
        ...mapState('sgaLanguages', ['language', 'action', 'languagesValidForApi'])
    },

    async created() {
        await this.getLanguagesValidForApi();
    },

    methods: {
        ...mapActions('sgaLanguages', ['createLanguageSga', 'getLanguagesSga', 'updateLanguageSga', 'getLanguagesValidForApi']),
        ...mapMutations('sgaLanguages', ['setDefaultLanguageSga']),

        cancelLanguage() {
            this.setDefaultLanguageSga();
            this.$bvModal.hide('modal_create_languages');
        },

        async cancelAndGetLanguages() {
            this.cancelLanguage();
            await this.getLanguagesSga();
        },

        async saveLanguage() {
            const isValid = await this.$validator.validateAll('formLanguages');
            if (!isValid) return;

            let flag = false;
            if (this.action === 'edit') {
                flag = await this.updateLanguageSga(this.language);
            } else {
                flag = await this.createLanguageSga(this.language);
            }

            if (flag) {
                this.cancelAndGetLanguages();
            }
        },

        // Buscar el nombre del lenguaje seleccionado, capturar el nombre y asignarlo al objeto language.
        setNameLanguage(code) {
            const languaje = this.languagesValidForApi.find(item => item.code === code);
            this.language.name = languaje ? languaje.name : null;
        },
    }
}
</script>
